"use client";

import { useEffect, useRef } from "react";

export default function AboutHeader() {
    const ref = useRef<HTMLDivElement>(null);

    useEffect(() => {
        const els = ref?.current?.querySelectorAll(".reveal");
        if (!els) return;
        const observer = new IntersectionObserver(
            (entries) =>
                entries.forEach((e) => {
                    if (e.isIntersecting) {
                        e.target.classList.add("visible");
                        observer.unobserve(e.target);
                    }
                }),
            { threshold: 0.1 }
        );
        els?.forEach((el) => observer?.observe(el));
        return () => observer?.disconnect();
    }, []);

    return (
        <section
            ref={ref}
            className="section-navy-mid"
            style={{ paddingTop: "30px", paddingBottom: "80px" }}
        >
            <div
                className="px-6 lg:px-12"
                style={{ maxWidth: "1280px", margin: "0 auto" }}
            >
                <div className="mb-8 reveal reveal-delay-1 justify-center text-center">
                    <p className="type-caption mb-2" style={{ color: "var(--color-red)" }}>SPECIFICATION FRAMEWORK</p>
                    <h2
                        style={{
                            fontFamily: "var(--font-serif)",
                            fontSize: "clamp(1.75rem, 3vw, 2.5rem)",
                            fontWeight: 400,
                            color: "var(--color-white)",
                            lineHeight: 1.15,
                            letterSpacing: "-0.015em",
                        }}
                    >
                        Tailored to Your Requirements
                    </h2>
                    <p className="type-body mt-4" style={{ maxWidth: "560px", margin: "0 auto", color: "rgba(255,255,255,0.55)" }}>
                        Each contract is tailored and finalized with refinery alignment. Typical parameters include:
                    </p>
                </div>

                <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 mt-8 reveal reveal-delay-2">
                    <div className="card p-6">
                        <h4
                            style={{
                                fontFamily: "var(--font-sans)",
                                fontSize: "0.8125rem",
                                fontWeight: 600,
                                letterSpacing: "0.08em",
                                textTransform: "uppercase",
                                color: "var(--color-white)",
                                marginBottom: "12px",
                            }}
                        >
                            Sb Payable %
                        </h4>
                        <p className="type-body text-sm" style={{ color: "rgba(255,255,255,0.55)" }}>
                            Assay-based payable percentage determined through agreed sampling protocols.
                        </p>
                    </div>
                    <div className="card p-6">
                        <h4
                            style={{
                                fontFamily: "var(--font-sans)",
                                fontSize: "0.8125rem",
                                fontWeight: 600,
                                letterSpacing: "0.08em",
                                textTransform: "uppercase",
                                color: "var(--color-white)",
                                marginBottom: "12px",
                            }}
                        >
                            Moisture Limits
                        </h4>
                        <p className="type-body text-sm" style={{ color: "rgba(255,255,255,0.55)" }}>
                            Strict moisture controls to ensure material integrity during transport.
                        </p>
                    </div>
                    <div className="card p-6">
                        <h4
                            style={{
                                fontFamily: "var(--font-sans)",
                                fontSize: "0.8125rem",
                                fontWeight: 600,
                                letterSpacing: "0.08em",
                                textTransform: "uppercase",
                                color: "var(--color-white)",
                                marginBottom: "12px",
                            }}
                        >
                            Impurity Thresholds
                        </h4>
                        <p className="type-body text-sm" style={{ color: "rgba(255,255,255,0.55)" }}>
                            Defined limits for As, Pb, Hg, Bi, Cu and other trace elements.
                        </p>
                    </div>
                    <div className="card p-6">
                        <h4
                            style={{
                                fontFamily: "var(--font-sans)",
                                fontSize: "0.8125rem", 
                                fontWeight: 600,
                                letterSpacing: "0.08em",
                                textTransform: "uppercase",
                                color: "var(--color-white)",
                                marginBottom: "12px",
                            }}
                        >
                            Sampling Protocol
                        </h4>
                        <p className="type-body text-sm" style={{ color: "rgba(255,255,255,0.55)" }}>
                            ISO-aligned sampling and assay procedures for consistent results.
                        </p>
                    </div>
                    <div className="card p-6">
                        <h4
                            style={{
                                fontFamily: "var(--font-sans)",
                                fontSize: "0.8125rem",
                                fontWeight: 600,
                                letterSpacing: "0.08em",
                                textTransform: "uppercase",
                                color: "var(--color-white)",
                                marginBottom: "12px",
                            }}
                        >
                            Packaging Standards
                        </h4>
                        <p className="type-body text-sm" style={{ color: "rgba(255,255,255,0.55)" }}>
                            Super-sacks with sealed liners, moisture-controlled and lot-traced.
                        </p>
                    </div>
                    <div className="card p-6">
                        <h4
                            style={{
                                fontFamily: "var(--font-sans)",
                                fontSize: "0.8125rem",
                                fontWeight: 600,
                                letterSpacing: "0.08em",
                                textTransform: "uppercase",
                                color: "var(--color-white)",
                                marginBottom: "12px",
                            }}
                        >
                            Assay Procedures
                        </h4>
                        <p className="type-body text-sm" style={{ color: "rgba(255,255,255,0.55)" }}>
                            Fully documented sampling and assay workflows with unique provisions.
                        </p>
                    </div>
                </div>
            </div>
        </section>
    );
}